import { Component, Input, AfterViewInit, ViewChild, Output, EventEmitter, WritableSignal, signal, Signal, computed, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { DisplayInvoiceDialogComponent } from '../display-invoice-dialog/display-invoice-dialog.component';
import { formatMoney } from 'src/utilities';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dynamictable',
    imports: [
        CommonModule,
        FormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatInputModule,
        MatMenuModule
    ],
    templateUrl: './dynamictable.component.html',
    styleUrls: ['./dynamictable.component.css']
})
export class DynamictableComponent implements AfterViewInit, OnChanges {
  constructor(public dialog: MatDialog) { }
 filters: any[] = [];
  isLoading: boolean = true;
  skeletonRows: any[] = new Array(5);
  @Input() inlineSearch: boolean = false;
  searchableColumns: string[] = ['Customer Name', 'AE/Sales Contact'];
  dialogRef!: MatDialogRef<any>;

  /**
   * Parent component instance for custom icon click handlers (e.g., Digital Copy PDF)
   */
  @Input() comp: any;

  private _dataSource: MatTableDataSource<any>;
  columnFilters: { [key: string]: string } = {}; // NEW: store per-column filters

  @Input()
  set dataSource(value: MatTableDataSource<any>) {
    this._dataSource = value;
    this.setFilterPredicate(); // NEW: set predicate for per-column filtering
    this.assignSort();
    // Reset loading state when new data arrives
    if (value && value.data) {
      this.isLoading = false;
    }
  }
  get dataSource(): MatTableDataSource<any> {
    return this._dataSource;
  }

  @Input() isFromGBS: boolean;
  @Input() isFromReports: boolean = false;
  @Input() displayedColumns: { label: string; propertyName: string; icons: { icon: string; toolTip: string; tooltipProperty?: string; 
    callFrom?: string;  }[]; }[] = [];
  @Input() isSearchRequired: boolean = true;
  @Input() isFromBulkUpload: boolean = false;
  @Input() hideFilterAndRefresh: boolean = false;

  @Input() totalCount: number;
  @Input() pageSize: number;
  @Input() useManualPaging: boolean;
  
  @Input() set activeFilters(value: any[]) {
    if (value && value.length > 0) {
      // Restore the filters array from parent's stored filters
      this.filters = value.map(f => ({ ...f }));
    }
  }

  @Output() paginationChange = new EventEmitter<{
    pageIndex: number;
    pageSize: number;
    isRefresh?: boolean;
  }>();
  @Output() filterChange = new EventEmitter<{
    filters: any[];
  }>();
  @Output() openDialog = new EventEmitter<any>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
  @ViewChild('bottomScroll') bottomScroll: ElementRef<HTMLDivElement>;

  length: number;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeFilters'] && changes['activeFilters'].currentValue) {
      const newFilters = changes['activeFilters'].currentValue;
      if (newFilters && newFilters.length > 0) {
        this.filters = newFilters.map(f => ({ ...f }));
      }
    }

    if (this.useManualPaging && this.paginator) {
      if (changes['totalCount'] || changes['pageSize']) {
        
        if (this.totalCount !== undefined) {
          this.paginator.length = this.totalCount;
        }

        if (this.pageSize !== undefined && this.pageSize !== this.paginator.pageSize) {
          this.paginator.pageSize = this.pageSize;
        }
      }
    }
  }

  ngAfterViewInit() {
    this.assignSort();
    this.initializeFilters();
    if (this.paginator && !this.useManualPaging && this._dataSource) {
      this._dataSource.paginator = this.paginator;
    }
    
    if (this.useManualPaging && this.paginator) {
      if (this.totalCount !== undefined) {
        this.paginator.length = this.totalCount;
      }
      if (this.pageSize !== undefined) {
        this.paginator.pageSize = this.pageSize;
      }
    }
  }

  initializeFilters() {
    if (this.filters.length === 0) {
      this.addFilter(); 
    }
  }

  assignSort() {
    if (this._dataSource && this.sort) {
      this._dataSource.sort = this.sort;
      this.length = this._dataSource.data.length;
    }
    if (this._dataSource) {
      this.isLoading = false;
    }
  }

  setFilterPredicate() {
    if (!this._dataSource) return;

    this._dataSource.filterPredicate = (data: any, filter: string) => {
      const filters = JSON.parse(filter);
      return Object.keys(filters).every(key => {
        const searchValue = filters[key].trim().toLowerCase();
        const dataValue = (data[key] ?? '').toString().trim().toLowerCase();
        return dataValue.includes(searchValue);
      });
    };
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filterPredicate = (data, filter) => {
      return JSON.stringify(data).toLowerCase().includes(filter);
    };
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

    applyColumnFilter(event: Event, column: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.columnFilters[column] = inputValue;

    // Update the datasource's filter with JSON of column filters
    this.dataSource.filter = JSON.stringify(this.columnFilters);
  }



  onPaginateChange(event: any): void {
    console.log('Paginator event:', event);
    this.paginationChange.emit({
      pageIndex: event.pageIndex,
      pageSize: event.pageSize
    });
  }

  onRefresh()
  {
    // this.paginationChange.emit({
    //     pageIndex: 1,
    //     pageSize: this.pageSize || 20
    // Clear all filters
    this.filters = [];
    this.columnFilters = {};
    if (this.dataSource) {
      this.dataSource.filter = '';
    }
    

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    

    this.paginationChange.emit({
        pageIndex: 0,
        pageSize: 10,
        isRefresh: true
      });
  }

  getColumnPropertyNames(): string[] {
    return this.displayedColumns.map(col => col.propertyName);
  }

  get FilteredColumns() {
    const allowedColumns = ['detailedAdjSubId', 'mms', 'statusName', 'statusDesc', 'customerName', 'adjReq', 'adjReqId', 'custName', 'ae', 'aeUser'];
    return this.displayedColumns.filter(col =>
      allowedColumns.some(allowed => col.propertyName.toLowerCase() === allowed.toLowerCase())
    );
  }


  isOpenDialog(details: object, callFrom: string) {
    if (callFrom === 'view' || callFrom === 'view-invoice') {
      const dialogRef = this.dialog.open(DisplayInvoiceDialogComponent, {
        width: '70vw',
        maxWidth: '75vw',
        panelClass: 'custom-dialog-container',
        position: { top: '10px' },
        data: { details, callFrom }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('Child dialog closed with result:', result);
      });
    } else {
      this.openDialog.emit({ details, callFrom });
    }
  }

  isOverflowing(propertyName: string, data: string) {
    if (propertyName !== 'icon') {
      const rawData = String(data).replace(/,/g, '');
      const length = rawData.length;
      const maxLength = propertyName === 'adjReq' ? 9 : 6;
      return length > maxLength;
    }
    return false;
  }

  getDisplayValue(propertyName: string, element: any): string {
    if (propertyName === 'adjNetAmount'|| propertyName==='totalCorrectCharges' || propertyName === 'statementAmt' || propertyName === 'invAdjAmt' ||
      propertyName === 'rebillAmount' || propertyName === 'totalInvoiceAmt' || propertyName === 'netAdjustmentAmount') return formatMoney(element[propertyName]);
    return element[propertyName] ? element[propertyName] : '--';
  }

  isNegative(propertyName: string, element: any) {
    const value = element?.[propertyName];
    if (propertyName === 'adjNetAmount' || propertyName==='totalCorrectCharges' || propertyName === 'statementAmt' || propertyName === 'invAdjAmt' ||
      propertyName === 'rebillAmount' || propertyName === 'totalInvoiceAmt' || propertyName === 'netAdjustmentAmount') {
      if (value < 0) {
        return { color: 'red' };
      }
    }
    return { color: 'inherit' };
  }

  rowColorMap: { [adjReqId: string]: string } = {};
  colors: string[] = [
    'group-color-1',
    'group-color-2',
    'group-color-3',
    'group-color-4',
    'group-color-5',
    'group-color-6',
    'group-color-7'
  ];
  currentColorIndex = 0;

  getStatusClass(status: string): string {
    switch (status) {
      case 'Submitted': return 'status-chip status-submitted';
      case 'PRS Submitted': return 'status-chip status-submitted';
      case 'MI Approved':
      case 'MIApproved': return 'status-chip status-first-approved';
      case 'First Level Rejected': return 'status-chip status-first-rejected';
      case 'First Level Need More Information': return 'status-chip status-need-info';
      case 'GBS Need More Information': return 'status-chip status-gbs-info';
      case 'Completed': return 'status-chip status-completed';
      case 'Received': return 'status-chip status-received';
      case 'Pending Rebill': return 'status-chip status-pending-rebill';
      case 'Rejected': return 'status-chip status-rejected';
      case 'Cancelled': return 'status-chip status-cancelled';
      case 'Saved': return 'status-chip status-saved';
      case 'Waiting for Approval': return 'status-chip status-waiting-approval'; 
      case 'Sent to Corrections': return 'status-chip status-sent-corrections';
      case 'Second level Need More Information': return 'status-chip status-second-need-info';
      case 'First Level Approved': return 'status-chip status-first-approved';
      case 'Second Level Rejected': return 'status-chip status-second-rejected';
      default: return 'status-chip';
    }
  }

  getcolorClass(row: any): string {
    const adjReqId = row?.adjReqId?.toString();
    if (!adjReqId) return '';

    if (this.rowColorMap[adjReqId]) {
      return this.rowColorMap[adjReqId];
    }

    const colorClass = this.colors[this.currentColorIndex % this.colors.length];
    this.rowColorMap[adjReqId] = colorClass;
    this.currentColorIndex++;
    return colorClass;
  }
  isSearchableColumn(columnLabel: string): boolean {
  return this.searchableColumns.includes(columnLabel);
}
getDynamicTooltip(icon: any, element: any): string {
  if (icon.tooltipProperty && element[icon.tooltipProperty]) {
    return element[icon.tooltipProperty];
  }
  return icon.toolTip || '';
}

applyFilters() {
  const mappedFilters = this.filters
    .filter(f => f.value !== null && f.value !== undefined && f.value.toString().trim() !== '') // ✅ keep only non-empty
    .map(f => {
      if (f.column === 'statusName') {
        const statusValue = f.value === 0
          ? [1,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,20].join(',')
          : f.value?.toString() || '';
        return {
          column: f.column,
          value: statusValue,
          operator: f.operator || 'contains'
        };
      } else {
        return {
          column: f.column,
          value: f.value?.toString().trim(),
          operator: f.operator || 'contains'
        };
      }
    });

  if (mappedFilters.length > 0) {
    // Reset paginator to first page when filters are applied
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    console.log('mapped filters;',mappedFilters);
    this.filterChange.emit({ filters: mappedFilters });
  } else {
    this.closeMenu();
  }
}

addFilter() {
  if (this.filters.length >= 5) {
    console.warn('Maximum of 5 filters allowed.');
    return;
  }

  const selectedColumns = this.filters.map(f => f.column).filter(c => c);

  const availableColumns = this.FilteredColumns
    .map(c => c.propertyName)
    .filter(c => !selectedColumns.includes(c));

  if (availableColumns.length === 0) {
    console.warn('No more columns available to select.');
    return;
  }
  this.filters.push({
    column: availableColumns[0],
    operator: 'contains',
    value: ''
  });
}


  removeFilter(index: number) {
    this.filters.splice(index, 1);
  }

  closeMenu() {
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }
  }

  isColumnAlreadySelected(columnPropertyName: string, currentFilter: any): boolean {
    return this.filters.some(filter => 
      filter.column === columnPropertyName && filter !== currentFilter
    );
  }

}
